import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import { KeyOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import cookie from "react-cookies";
import AUTH from "../../constants/Auth";
export default function LoginForm({ requiresOTP, onDoLogin, onUsernameChanged }) {
    const [form] = Form.useForm();
    useEffect(() => {
        const username = cookie.load(AUTH.rememberMeCookieName);
        if (username) {
            form.setFieldsValue({
                username: username,
                remember: true
            });
        }
    }, []);
    const onFinish = (formValues) => {
        onDoLogin({
            username: formValues.username,
            password: formValues.password,
            oneTimePassword: formValues.oneTimePassword,
            rememberMe: formValues.remember
        });
    };
    return (_jsxs(Form, { initialValues: { remember: true }, onFinish: onFinish, className: "login-form", form: form, children: [_jsx(Form.Item, { name: "username", rules: [{ required: true, message: 'Please input your username!' }], children: _jsx(Input, { prefix: _jsx(UserOutlined, {}), placeholder: "Username", autoComplete: "username", onChange: onUsernameChanged }) }), _jsx(Form.Item, { name: "password", rules: [{ required: true, message: 'Please input your Password!' }], children: _jsx(Input.Password, { prefix: _jsx(KeyOutlined, {}), type: "password", autoComplete: "new-password", placeholder: "Password" }) }), requiresOTP &&
                _jsx(Form.Item, { name: "oneTimePassword", label: "Enter passcode", rules: [{ required: true, message: 'Please enter a one time password using your authenticator device' }], children: _jsx(Input.OTP, {}) }), _jsx(Form.Item, { name: "remember", valuePropName: "checked", children: _jsx(Checkbox, { children: "Remember me" }) }), _jsxs(Button, { type: "primary", size: "large", htmlType: "submit", className: "submit-button", children: [_jsx(LockOutlined, {}), "\u00A0 Log in"] })] }));
}
